import {DataStatus} from 'platform/components';

import {useState} from 'react';

import {isNotNil} from 'ramda';

import {useGetWhatsAppConnectionQuery} from '@dms/api/settings';

import {WhatsAppConnect} from '../WhatsAppConnect/WhatsAppConnect';
import {WhatsAppConnectionStatus} from '../WhatsAppConnectionStatus/WhatsAppConnectionStatus';

export function WhatsAppConnection() {
  const {data: connection, isLoading, isError} = useGetWhatsAppConnectionQuery();
  // A reconnect runs the signup wizard while the current connection keeps working until replaced.
  const [isReconnecting, setIsReconnecting] = useState(false);

  const isConnected = isNotNil(connection) && connection.configurationState !== 'not_configured';

  return (
    <DataStatus isLoading={isLoading} isError={isError}>
      {isConnected && !isReconnecting ? (
        <WhatsAppConnectionStatus
          connection={connection}
          onReconnect={() => setIsReconnecting(true)}
        />
      ) : (
        <WhatsAppConnect
          onBack={isConnected ? () => setIsReconnecting(false) : undefined}
          onConnected={() => setIsReconnecting(false)}
        />
      )}
    </DataStatus>
  );
}
